import React from 'react';
// import { useSelector } from 'react-redux';
// import { selectAllCourses } from "../../redux-store/dashboardSlice/dashboardSliceSelectors"
import { Card, CardContent, Typography, IconButton, Box } from '@mui/material';
import { styled } from '@mui/system';
import CallMadeOutlinedIcon from '@mui/icons-material/CallMadeOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const CustomCard = styled(Card)(({ theme }) => ({
    backgroundColor: '#f5c72f',
    borderRadius: 12,
    padding: theme.spacing(2),
    height: '120px',
    width: '100%',
}));

const InfoText = styled(Typography)(({ theme }) => ({
    color: '#ffffff', // White text color
}));

const ArrowIconButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: '#ffffff',
    color: '#f5c72f',
    marginBottom: "15px !important",
    marginRight: "10px !important",
    alignSelf: 'flex-end',
    '&:hover': {
        backgroundColor: '#ffffff',
    },
}));


export const CoursesTotalBlock = () => {
    // const coursesCount = useSelector((state) => selectAllCourses(state)?.length);

    return (
        <CustomCard>
            <Box display="flex" flexDirection="column">
                <InfoText variant="h5" fontWeight={500} >
                    1400+
                </InfoText>
                <InfoText variant='caption' fontSize="10px" sx={{ opacity: 0.9 }}>
                    Product Courses Completed
                </InfoText>
            </Box>
            <Box mt={1} display="flex" justifyContent="flex-end">
                <ArrowIconButton size="small">
                    <CallMadeOutlinedIcon size="small" />
                </ArrowIconButton>
            </Box>
        </CustomCard>
    )
}


const CustomCard2 = styled(Card)(({ theme }) => ({
    backgroundColor: '#ef5350',
    borderRadius: 12,
    padding: theme.spacing(2),
    height: '120px',
    width: '100%',
}));

const ArrowIconButton2 = styled(IconButton)(({ theme }) => ({
    backgroundColor: '#ffffff',
    color: '#ef5350',
    marginBottom: "15px !important",
    marginRight: "10px !important",
    alignSelf: 'flex-end',
    '&:hover': {
        backgroundColor: '#ffffff',
    },
}));


export const SellingCoursesTotalBlock = () => {
    return (
        <CustomCard2>
            <Box display="flex" flexDirection="column">
                <InfoText variant="h5" fontWeight={500} >
                    200+
                </InfoText>
                <InfoText variant='caption' fontSize="10px" sx={{ opacity: 0.9 }}>
                    Selling Courses Completed
                </InfoText>
            </Box>
            <Box mt={1} display="flex" justifyContent="flex-end">
                <ArrowIconButton2 size="small">
                    <CallMadeOutlinedIcon size="small" />
                </ArrowIconButton2>
            </Box>
        </CustomCard2>
    )
}
